export interface User {
  userId: string;
  name: string;
  agentStartedAt?: Date;
  /**
   * 商業化希望フラグ
   * 用途: 後続の応募レコメンド等の切り分け（一定文字数到達時など）
   * 非用途: 企画マッチングの FAB / 依頼ボタンの表示ゲートには使わない
   * 未設定時はバックエンドが false を返す
   */
  wantsCommercialization?: boolean;
}

/** updateUser の入力（name / wantsCommercialization を個別更新可能） */
export interface UpdateUserInput {
  name?: string;
  wantsCommercialization?: boolean;
}

export enum Plan {
  /** 無料会員 */
  free = 0,
  /** 月額会員 */
  monthly = 1,
  /** 年額会員 */
  yearly = 2,
  /** スクール会員 */
  school = 3,
}

export interface ConnectedOtherServices {
  nolaPublishing: ExistsOtherServiceUser;
  nolaNovel: ExistsOtherServiceUser;
}

interface ExistsOtherServiceUser {
  result?: boolean;
  error?: string;
}

const Segment = {
  /** 商業化希望 */
  SEG001: "SEG001",
} as const;
export type SegmentType = typeof Segment[keyof typeof Segment];
